import OrganizationsSelectorContainer from './organizations_selector_container';

const OrganizationsSelector = OrganizationsSelectorContainer;
export default OrganizationsSelector;
